<template>
<div class="page-modal">
    <!-- <img :src="$store.state.static_img_url + 'pic/model/vip-model-icon.png'" /> -->
    <p class="p1">普通用户查询数量受限</p>
    <p class="p2">开通动脉橙机构版，可查看完整内容</p>
    <div @click="go" class="go-vip-btn">申请试用</div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    go() {
      let link = this.$store.state.index_path + '/applyTry?info_src=35'
      window.open(link)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.page-modal
  commonBgImg('~pic/model/black-list.png', '~pic/model/white-list.png') no-repeat;
  // background: url('~pic/model/vip-model.png') no-repeat
  background-size: 100%
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  height: 376px
  .p1
    commonColor(#bcbdc1, #553204)
    font-size: 24px
    font-weight:600
  .p2
    commonColor(#bcbdc1, #553204)
    font-size: 16px
    margin-top: 12px
  .go-vip-btn
    width:150px
    height:40px
    background:rgba(255,234,197,1)
    border-radius:20px
    color: #553204
    font-size:14px
    text-align: center
    line-height: 40px
    margin-top: 40px
    cursor pointer
</style>
